module.exports = __webpack_public_path__ + "static/media/point+6.426a9106.png";